<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="scroll-container card" fullscreen>
    <ef-indirect-rate
        [selectedError]="selectedErrorWithStatus$ | async"
        (ShowError)="onShowError($event)"
    ></ef-indirect-rate>
</div>
